import type { ReactNode } from "react";
import { AlertCircle } from "lucide-react";

/**
 * Form-level error, as a boxed alert rather than a bare red line.
 *
 * Self-nulls on falsy children so it can sit unconditionally in a form —
 * `<ErrorText>{error}</ErrorText>` — without a surrounding conditional at every
 * call site.
 */
export function ErrorText({ children }: { children: ReactNode }) {
  if (!children) return null;

  return (
    <p
      role="alert"
      className="flex items-start gap-1.5 rounded-lg border border-danger-border bg-danger-bg px-3 py-2 text-sm text-danger"
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      {children}
    </p>
  );
}
